/**
 * Contact page map, added with Mapify
 */
$(function() {
    var box = $('.page-contact-content > .map');

    var styles = [
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#d3e3f0"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#cfedbe"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#333333"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        }
    ];

    // Calculate the Y axis offset for the map centre. At small screen sizes,
    // the content does not overlap the map and so there is no offset. At larger
    // sizes, some of the map is obscured by the content and so the centre must
    // be adjusted.
    var offset = function() {
        if ($(window).width() > 1279) {
            return (20 * 16) / 2;
        }

        if ($(window).width() > 959) {
            return (16 * 16) / 2;
        }

        if ($(window).width() > 799) {
            return (12 * 16) / 2;
        }

        return 0;
    };

    // If there are no map containers, do nothing.
    if (box.length === 0) {
        return;
    }

    // Use Mapify to add a map to the map container, using the settings from the
    // data attributes on the HTML map container.
    box.mapify({
        points: [
            {
                lat: parseFloat(box.data('lat')),
                lng: parseFloat(box.data('lng')),
                title: box.data('title'),
                marker: box.data('icon')
            }
        ],
        // zoom: 15,
        key: 'AIzaSyA3wN0O_8OzFGBBdvzJgWvqlcg9QEDFRh0',

        // Because of the Y axis offset required at some screen sizes, we will
        // manage responsiveness with a callback instead of the built-in
        // responsive function.
        responsive: false,

        // Adjust the centre of the map by the required Y offset on the first
        // time the map loads and when the window is resized.
        callback: function(map, bounds, settings) {
            // Disable scroll wheel zoom to avoid the anger, leading to hate and
            // the dark side.
            map.setOptions({
                fullscreenControl: true,
                mapTypeControl: false,
                scrollwheel: false,
                streetViewControl: false,
                styles: styles
            });

            // Adjust the centre the first time the map loads.
            google.maps.event.addListenerOnce(map, 'idle', function() {
                map.setZoom(15);
                map.panBy(0, offset());
            });

            // Adjust the centre every time the window is resized.
            $(window).on('resizeDone', function() {
                var position = new google.maps.LatLng(
                    settings.points[0].lat,
                    settings.points[0].lng
                );

                map.setCenter(position);
                map.panBy(0, offset());
            });
        }
    });
});
